module.exports = "https://cdn.hellotech.com/client-assets/chat-off-hours-mobile_42bb262fd9d14e1d26912fadff6eb0ec.png";